const storagePrefix = "content-popup-seen";

export const getPromotionSeenKey = (userId, messageId) => `${storagePrefix}_${userId}_${messageId}`;

export const isPromotionSeen = (userId, messageId) => {
    if (!userId || !messageId)
        return false;
    return localStorage.getItem(getPromotionSeenKey(userId, messageId)) === "true";
};

export const markPromotionSeen = (userId, messageId) => {
    if (!userId || !messageId)
        return;
    localStorage.setItem(getPromotionSeenKey(userId, messageId), "true");
};
